// Module
var code = "<td class=\"timewriting-table-column__value integer\"> <span data-bind=\"text: FormatValue(_cell.Value())\"></span> </td>";
// Exports
export default code;